<template>
  <div
    class="premium-personal-account-cell"
    :class="{ 'premium-personal-account-cell_disabled': !canEdit }"
    @click="canEdit && (isShowPersonalAccountInfoModal = true)"
  >
    <c-sidesheet
      class="premium-personal-account-cell-sidesheet"
      :active="isShowPersonalAccountInfoModal"
      @close="closePersonalAccountInfoModal"
    >
      <svg
        class="premium-personal-account-cell-sidesheet-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closePersonalAccountInfoModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="premium-personal-account-cell-title">
        <div class="premium-personal-account-cell-title-desc">Личный счет</div>
        <router-link
          target="_blank"
          :to="{ name: 'personal-employee-summary', params: { id: record.id } }"
          class="premium-personal-account-cell-title-link"
        >
          {{ record.employee.value }}
        </router-link>
      </div>
      <div class="premium-personal-account-cell-sidesheet-table">
        <div v-if="isDataLoading" class="premium-personal-account-cell-sidesheet-table-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <c-table-data-personal-transactions
          v-if="!isDataLoading"
          ref="table"
          class="premium-personal-account-cell-sidesheet-table-table"
          empty-records-label="Записи не найдены"
          :levels="1"
          :disabled-columns="tableData.disabledColumns"
          :data="tableData"
        />
      </div>
    </c-sidesheet>
    <div class="premium-personal-account-cell-value">
      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'История личного счета сотрудника',
          placement: 'top',
        }"
        class="premium-personal-account-cell-value-button"
        size="iconic"
        icon="menu"
      />
      {{ record.premium_personal_account.value }}
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Sidesheet from "@/components/sidesheet";
import Button from "@/components/controls2/Button";
import DataTablePersonalTransactions from "@/pages/calculations/create/additions/sidesheet-additions/data-table-personal-transactions";

export default {
  name: "production-cell-premium-personal-account",
  components: {
    "c-sidesheet": Sidesheet,
    "c-button": Button,
    "c-table-data-personal-transactions": DataTablePersonalTransactions,
    FontAwesomeIcon,
  },
  props: ["calculationData", "record", "calculationType", "canEdit"],
  data() {
    return {
      icon: faSpinner,
      isShowPersonalAccountInfoModal: false,
      isDataLoading: true,
      personalTransactionsColumns: [
        {
          id: "date",
          label: "Дата",
          fullName: "Дата",
          type: "date",
          width: "15%",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "balance",
          label: "Остаток лс на начало дня, ฿",
          fullName: "Остаток лс на начало дня, ฿",
          type: "number",
          width: "11.5%",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "sum_salary",
          label: "Начислено осн. часть, ฿",
          fullName: "Начислено осн. часть, ฿",
          type: "number",
          width: "12%",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "sum_dynamic",
          label: "Начислено перем. часть, ฿",
          fullName: "Начислено переменная часть, ฿",
          type: "number",
          width: "12%",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "sum_bonus",
          label: "Премия, ฿",
          fullName: "Премия, ฿",
          width: "11%",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "sum_penalty",
          label: "Штраф, ฿",
          fullName: "Штраф, ฿",
          width: "11%",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "amount",
          label: "Внесено/снято, ฿",
          fullName: "Внесено/снято, ฿",
          width: "10%",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "balance_end",
          label: "Остаток лс на конец дня, ฿",
          fullName: "Остаток лс на конец дня, ฿",
          width: "11.5%",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      tableData: {
        type: "delivery-orders-table",
        columns: [],
        records: [],
        actions: true,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
    };
  },
  watch: {
    isShowPersonalAccountInfoModal(value) {
      const periodStart = moment(this.calculationData.period.calculation.datetime).format("YYYY-MM-DD");
      const periodEnd = moment(this.calculationData.period.calculation.datetime_end).format("YYYY-MM-DD");
      this.tableData.columns = this.personalTransactionsColumns;
      if (value) {
        this.$store
          .dispatch("calculations/getPersonalAccountHistoryCalculationByPeriod", {
            filialId: this.calculationData.period.calculation.filial_id,
            periodStart,
            periodEnd,
            workerId: this.record.id,
          })
          .then((res) => {
            const datesCount = [];
            res.forEach((record) => {
              const findIndexDate = datesCount.findIndex((item) => item.requestDate === record.date);
              if (findIndexDate === -1) {
                datesCount.push({
                  requestDate: record.date,
                  date: {
                    value: moment(record.date).format("DD.MM.YYYY"),
                  },
                  count: 1,
                  balance: {
                    value: 0,
                  },
                  sum_salary: {
                    value: 0,
                  },
                  sum_dynamic: {
                    value: 0,
                  },
                  sum_bonus: {
                    value: 0,
                  },
                  sum_penalty: {
                    value: 0,
                  },
                  amount: {
                    value: 0,
                  },
                  balance_end: {
                    value: 0,
                  },
                  childrens: [],
                  isShowRow: true,
                });
              } else {
                datesCount[findIndexDate].count += 1;
              }
            });

            const records = datesCount.map((item) => {
              //console.log(res, item);
              res.forEach((record) => {
                if (record.date === item.requestDate) {

                  if (item.count === 1) {
                    item.calcId = record.calc_id;
                    item.balance.value += Math.round(record.balance);
                    item.sum_salary.value += Math.round(record.sum_salary);
                    item.sum_dynamic.value += Math.round(record.sum_dynamic);
                    item.sum_bonus.value += Math.round(record.sum_bonus);
                    item.sum_penalty.value += Math.round(record.sum_penalty);
                    item.amount.value += Math.round(record.amount);
                    item.balance_end.value += Math.round(record.balance_end);
                  } else {

                    item.sum_salary.value += Math.round(record.sum_salary);
                    item.sum_dynamic.value += Math.round(record.sum_dynamic);
                    item.sum_bonus.value += Math.round(record.sum_bonus);
                    item.sum_penalty.value += Math.round(record.sum_penalty);
                    item.amount.value += Math.round(record.amount);
                    item.childrens.push({
                      calcId: record.calc_id,
                      workerName: record.worker_name,
                      balance: {
                        value: Math.round(record.balance),
                      },
                      sum_salary: {
                        value: Math.round(record.sum_salary),
                      },
                      sum_dynamic: {
                        value: Math.round(record.sum_dynamic),
                      },
                      sum_bonus: {
                        value: Math.round(record.sum_bonus),
                      },
                      sum_penalty: {
                        value: Math.round(record.sum_penalty),
                      },
                      amount: {
                        value: Math.round(record.amount),
                      },
                      balance_end: {
                        value: Math.round(record.balance_end),
                      },
                      isShowRow: true,
                    });
                    item.balance.value = item.childrens[0].balance.value;
                    item.balance_end.value = item.childrens[item.childrens.length-1].balance_end.value;
                  }
                }
              });
              return item;
            });

          console.log(this.tableData);

            this.tableData.records = [...records]; 

            setTimeout(() => {
              this.isDataLoading = false;
            }, 500);
          });
      }
    },
  },
  methods: {
    closePersonalAccountInfoModal() {
      this.$emit("close");
      setTimeout(() => {
        this.isShowPersonalAccountInfoModal = false;
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.premium-personal-account-cell {
  height: 100%;

  &:after {
    background: transparent;
    border-top: 0 !important;
    border-bottom: 0 !important;
  }

  &:hover {
    outline-style: solid;
    outline-width: 1px !important;
    outline-color: #0066ff !important;
    box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
  }

  &-value {
    display: flex;
    justify-content: space-between;
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    cursor: pointer;
    align-items: center;

    &-button {
      margin-right: 10px;
      margin-top: 2px;
    }
  }

  &-title {
    display: flex;
    align-items: center;

    &-desc {
      font-weight: 500;
      font-size: 22px;
      line-height: 108%;
      color: #000000;
      margin-right: 5px;
    }

    &-link {
      text-decoration: none;
      font-weight: 500;
      font-size: 22px;
      line-height: 108%;
      color: #0066ff;
    }
  }

  &-sidesheet {
    position: relative;

    ::v-deep .sidesheet__header {
      flex-basis: 0;
    }

    ::v-deep .sidesheet__wrapper {
      width: calc(100vw - 161px);
      padding: 38px 0 38px 31px;

      @media screen and (max-width: 1024px) {
        width: calc(100vw - 62px);
      }

      @media screen and (max-width: 700px) {
        padding: 28px 20px;
        max-width: 100%;
        width: 100%;
      }
    }

    &-close {
      position: absolute;
      top: 12px;
      right: 12px;
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &-table {
      width: 100%;
      height: 100%;
      margin-top: 29px;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 24px;
        // height: 24px;
        // height: calc(100vh - 24px);
        background: white;
        cursor: pointer;
        // box-shadow: $box-shadow-container;
        z-index: 300;
        position: relative;

        @media (max-width: 992px) {
          display: none;
        }
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 12px;
        background-clip: padding-box;
        border: 10px solid#fff;

        // @media (max-width: 992px) {
        //     display: none;
        // }
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
        width: 4px;
        background: white;
        z-index: 300;
        position: relative;

        @media (max-width: 992px) {
          display: none;
        }
      }

      &-table {
        width: 100%;
        max-width: 720px;

        @media screen and (max-width: 700px) {
          width: calc(100% + 41px);
        }

        &::v-deep .ps__rail-y {
          opacity: 0 !important;
        }

        &::v-deep .c-table__shadow {
          opacity: 0 !important;
        }

        &::v-deep .c-table__container td:after,
        &::v-deep .c-table__container th:after,
        &::v-deep .c-table__container td:before,
        &::v-deep .c-table__container th:before {
          background: transparent !important;
          border: 0 !important;
          width: 0 !important;
          height: 0 !important;
        }
        &::v-deep .c-table__record__highlight td:first-child:before {
          border-top: none !important;
          border-bottom: none !important;
          border-left: none !important;
        }

        &::v-deep .c-table__cell,
        &::v-deep .c-table__column {
          position: static !important;
        }
      }

      &-loader {
        display: flex;
        font-size: 32px;
        width: 100%;
        height: 100%;
        justify-content: center;
        color: #ff238d;

        @media screen and (max-width: 700px) {
          padding-bottom: 20px;
        }
      }
    }
  }

  &_disabled {
    cursor: default;

    &:hover {
      outline: none;
      box-shadow: none;
    }
  }
}
</style>
